module.exports = "<div>\r\n  <a (click)=\"setTranslation('rs')\" [class.selected]=\"isSelected('rs')\">MNE</a>\r\n  <a> | </a>\r\n  <a (click)=\"setTranslation('en')\" [class.selected]=\"isSelected('en')\">ENG</a>\r\n  <a> | </a>\r\n  <a (click)=\"setTranslation('ru')\" [class.selected]=\"isSelected('ru')\">RU</a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/languages/languages.component.html
// module id = 770
// module chunks = 1